import http from 'services/http-service';

const BankAccountService = {
    GetMemberBankAccounts() {
        let response = http.get('/bankaccounts/member');
        return response;
    }
};

export default BankAccountService;